import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/Button';
interface AboutSectionProps {
  condensed?: boolean;
}
export function AboutSection({
  condensed = false
}: AboutSectionProps) {
  const navigate = useNavigate();
  return <section id="about" className="py-24 bg-beige relative overflow-hidden" data-id="element-16">
      <div className="absolute top-0 right-0 w-1/2 h-full pattern-dots opacity-30 pointer-events-none" data-id="element-17"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-18">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-19">
          {/* Text Side (Now on the left) */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2" data-id="element-20">
            <span className="text-jet font-medium tracking-[0.2em] uppercase mb-4 block" data-id="element-21">
              Welcome
            </span>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-jet mb-6" data-id="element-22">
              Welcome to <br data-id="element-23" />
              <span className="text-jet" data-id="element-24">Beni's African Hair Braiding.</span>
            </h2>

            {condensed ? <>
                <div className="space-y-4 text-jet/80 text-lg leading-relaxed" data-id="element-25">
                  <p data-id="element-26">
                    Where cultural heritage meets contemporary elegance. We
                    blend generations of traditional braiding techniques with
                    modern trends to create protective styles as unique as you
                    are.
                  </p>
                </div>
                <div className="mt-8" data-id="element-27">
                  <Button variant="outline" size="md" onClick={() => navigate('/about')} data-id="element-28">
                    Read More About Us
                  </Button>
                </div>
              </> : <div className="space-y-6 text-jet/80 text-lg leading-relaxed" data-id="element-29">
                <p data-id="element-30">
                  Step into a space where cultural heritage meets contemporary
                  elegance. Located at 2768 Crain Hwy, Waldorf, MD 20601, Beni's
                  African Hair Braiding is a sanctuary dedicated to the ancient,
                  beautiful art of protective styling. We take immense pride in
                  our roots, seamlessly blending generations of traditional
                  braiding techniques with modern trends to create styles that
                  are as unique as you are.
                </p>

                <ul className="space-y-4 mt-6" data-id="element-31">
                  <li className="flex items-start" data-id="element-32">
                    <span className="text-golden mr-3 mt-1.5 text-xl" data-id="element-33">•</span>
                    <div data-id="element-34">
                      <strong className="text-jet font-heading text-xl block mb-1" data-id="element-35">
                        Heritage & Artistry
                      </strong>
                      <span className="text-jet/70 text-base" data-id="element-36">
                        We honor the rich history of African braiding by
                        preserving authentic methods, while continuously
                        evolving our craft with modern, tension-free techniques
                        that protect your natural hair.
                      </span>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-37">
                    <span className="text-golden mr-3 mt-1.5 text-xl" data-id="element-38">•</span>
                    <div data-id="element-39">
                      <strong className="text-jet font-heading text-xl block mb-1" data-id="element-40">
                        Skilled Stylists
                      </strong>
                      <span className="text-jet/70 text-base" data-id="element-41">
                        Our dedicated team of master braiders is passionate
                        about celebrating your individuality, working
                        meticulously to enhance your natural beauty and ensure
                        you leave our chair feeling confident and radiant.
                      </span>
                    </div>
                  </li>
                </ul>
              </div>}

            <div className="mt-10 grid grid-cols-2 gap-6 border-t border-jet/15 pt-8" data-id="element-42">
              <div data-id="element-43">
                <h4 className="font-heading text-3xl font-bold text-jet mb-2" data-id="element-44">
                  10+
                </h4>
                <p className="text-sm font-medium text-jet/60 uppercase tracking-wider" data-id="element-45">
                  Years Experience
                </p>
              </div>
              <div data-id="element-46">
                <h4 className="font-heading text-3xl font-bold text-golden mb-2" data-id="element-47">
                  5k+
                </h4>
                <p className="text-sm font-medium text-jet/60 uppercase tracking-wider" data-id="element-48">
                  Happy Clients
                </p>
              </div>
            </div>
          </motion.div>

          {/* Image Side (Now on the right) */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full lg:w-1/2 relative" data-id="element-49">
            <div className="aspect-[4/5] bg-burgundy rounded-t-full relative overflow-hidden p-2 shadow-2xl" data-id="element-50">
              <div className="absolute inset-0 border-4 border-golden/30 rounded-t-full m-4 z-20 pointer-events-none" data-id="element-51"></div>
              <div className="w-full h-full bg-jet rounded-t-full overflow-hidden relative" data-id="element-52">
                <img src="https://cdn.magicpatterns.com/uploads/kSniEY7gVLzdZHwCui8KJF/Capture2.jpg" alt="Beautiful braided hair style at Beni's African Hair Braiding" className="w-full h-full object-cover" data-id="element-53" />
                <div className="absolute inset-0 bg-gradient-to-tr from-brown/40 to-transparent mix-blend-overlay" data-id="element-54"></div>
              </div>
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-golden rounded-full -z-10" data-id="element-55"></div>
            <div className="absolute top-1/4 -left-8 w-16 h-16 border-4 border-burgundy rounded-full -z-10" data-id="element-56"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}